<template>
  <div class="default-container">
    <header-game
      :newMessages="newMessages"
      :loader="loader"
      :timeToInit="clock"
      :view="view"
      :score="score"
      :clockTime="clock"
    ></header-game>
    <router-view :timer="clock" :db="db"></router-view>
  </div>
</template>
<script>
import HeaderGame from "../components/Sections/HeaderGame.vue";
import date from "../helpers/date";
import game from "../helpers/game.js";
import moment from "moment";
moment.locale("pt-br");
import decodeApi from "../api/decode";
import firebase from "../firebase/firebase.js";
import io from "socket.io-client";
import Bus from "../main.js";
import Firebase from "firebase";
import tagManager from "../helpers/integrationManager"
export default {
  components: {
    HeaderGame
  },
  data() {
    return {
      view: "",
      clock: "",
      score: "",
      timeout: "",
      timeoutSecond: "",
      intervalId: "",
      loader: true,
      newMessages: "",
      db: ""
      // socket : io('https://chat-service-kubernetes.huddlebrasil.com'),
    };
  },
  async created() {
    const db = firebase.constructDB();
    this.db = db;
    Bus.$on("sendMessage", this.sendMessage);
    Bus.$on("initClockStart", this.initClock);
    const { startedAt, score } = await this.$store.getters.getSimple([
      "startedAt",
      "score"
    ]);
    // console.log("startedAt: ", startedAt);
    this.$store.subscribe((mutation, state) => {
      this.score = state.persistence.score;
      // if(!state.persistence.score || state.persistence.score == 0){
      //     this.score = score
      // }
      this.newMessages = state.persistence.newMessages;
    });

    await this.socketsConnect();
    if (startedAt) {
      this.initClock(startedAt);
    }
  },
  async mounted() {
    const self = this;
    window.addEventListener("focus", async function() {
      const { startedAt, typeExtract } = await self.$store.getters.getSimple([
        "startedAt",
        "typeExtract"
      ]);
      // console.log(typeExtract);
      if (!typeExtract) {
        self.initClock(startedAt);
      }
    });
    window.addEventListener("blur", function() {
      self.endClock();
    });
  },
  destroyed() {
    clearTimeout(this.timeout);
    clearInterval(this.intervalId);
    Bus.$off("sendMessage");
    Bus.$off("initClockStart");
    window.removeEventListener("focus", () => {
      return;
    });
    window.removeEventListener("blur", () => {
      return;
    });
  },
  methods: {
    async sendMessage(chatId, newMessage) {
      // this.socket.emit('saveMessage', chatId, newMessage)
      try {
        const { teamGameId } = await this.$store.getters.getSimple([ "teamGameId" ]);
        // const { teamGameId } = undefined;
        // .doc(teamGameId)
        await this.db
          .collection("teamGames")
          .doc(teamGameId)
          .update({
            messages: Firebase.firestore.FieldValue.arrayUnion(newMessage)
          });
      } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("error on socket update: ", error)
        let { teamGameId, groupId, group, userId } = await this.$store.getters.getSimple(['teamGameId', 'groupId', 'group', 'userId'])
        let errorBody = { teamGameId, groupId, group, userId }
        errorBody.workspaceId = localStorage.getItem("workspaceId")
        errorBody.firebaseError = error
        errorBody.line = "108"
        errorBody.file = "GameDefaultContainer.vue"
        // console.log("errorBody: ", errorBody)
        
        const { data: res } = await decodeApi.post(`/logs`,errorBody)
        // location.reload()
      }
    },
    async socketsConnect() {
      // let self = this
      // const { chatId } = await this.$store.getters.getSimple(['chatId'])
      // this.socket.emit('joinRoom', chatId)
      // this.socket.emit('initialChat', chatId)
      // this.socket.on('chat', async chat => {
      //     let messages = chat.messages
      //     self.$store.dispatch('simpleSave', {
      //         messages
      //     })
      //     Bus.$emit('scrollToBottom')
      // })
      // this.socket.on('newMessage', (data) =>{
      //     console.log('chegou msg')
      //     self.$store.commit('NEW_MESSAGE')
      //     self.$store.commit('PUSH_MESSAGE', data)
      // })
      let messages = [];
      let messagesLength = 0;
      let firstAcess = true;
      let self = this;
      try {
        const { teamGameId } = await this.$store.getters.getSimple(["teamGameId"]);
        this.db.collection("teamGames").doc(teamGameId).onSnapshot(snapshot => {
          let messagesBot = localStorage.getItem("messagesBot");
          messagesBot = JSON.parse(messagesBot);
          let messagesSnap = messagesBot ? messagesBot : [];
          if (snapshot.exists && snapshot.data().messages) {
            snapshot.data().messages.forEach(message => {
              messagesSnap.push(message);
              // console.log("snapshot exists")
            });
          }
          messages = messagesSnap;
          if (messagesBot && messagesBot.length > 7) {
            self.$store.dispatch("simpleSave", {
              messages
            });
            if (firstAcess) {
              firstAcess = false;
              messagesLength = messagesSnap.length;
              return;
            } else {
              if (messagesLength < messagesSnap.length) {
                self.$store.commit("NEW_MESSAGE");
                let chatMessages = document.querySelector(".chat-messages");
                let scrollMax = 180;
                if (chatMessages) {
                  let scrollElement = chatMessages.scrollTop;
                  let chatViewHeight = chatMessages.clientHeight;
                  let heightMax = chatMessages.clientHeight + 100;
                  if (chatMessages.scrollHeight - scrollElement >= heightMax) {
                    Bus.$emit("countMessage");
                    // Bus.$emit('toggleIcon', true)
                  } else {
                    Bus.$emit("scrollToBottomMessage");
                    // Bus.$emit('toggleIcon', false)
                  }
                }
                messagesLength = messagesSnap.length;
              }
            }
          }
        });
      } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("error on snapshot: ", error)
      }
    },
    async getNow() {
      const responseNow = await decodeApi.get("/team-games/now");
      let now = moment(responseNow.data)
        .tz("America/Sao_Paulo")
        .format();
      return now;
    },
    endClock() {
      this.loader = true;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        // console.log(this.intervalId);
        this.clock = "";
      }
    },
    async initClock(createdAt) {
      const {
        group,
        attempts,
        teamGameId
      } = await this.$store.getters.getSimple([
        "group",
        "attempts",
        "teamGameId"
      ]);
      clearInterval(this.intervalId);
      // console.log(this.intervalId);
      let self = this;
      let createdMoment = date.timestampToMoment(createdAt);

      createdMoment = moment(createdMoment).add(30, "minutes");
      createdMoment = moment(createdMoment).add(3, "hours");
      let now = await this.getNow();
      now = moment(now).format();
      let startGame = moment(createdMoment).diff(now, "seconds");
      let diffHours = moment(createdMoment).diff(now, "hours");
      let diffDays = moment(createdMoment).diff(now, "days");
      if (startGame < 0 || diffHours < 0 || diffDays <= -1) {
        await this.endGame();
        return;
      }
      let timer = moment("2015-01-01")
        .startOf("day")
        .seconds(startGame);
      this.loader = false;
      this.intervalId = setInterval(async () => {
        timer = timer.subtract(1, "seconds");
        this.clock = timer.format("mm:ss");
        if (this.clock <= "00:00") {
          this.endClock();
          await this.endGame();
        }
      }, 1000);
    },
    async endGame() {
      clearInterval(this.intervalId);
      // console.log(this.intervalId);
      // const workspaceId = localStorage.getItem("workspaceId")
      // if(this.$store.getters.getWsWithTagManager.includes(workspaceId)){
      //   console.log("Entrou no if da Gupy")
      //   const { data: player } = JSON.parse(localStorage.getItem("player"))
      //   delete player.cpf
      //   const tag = "Finalizou o Decode Game"
      //   await tagManager(tag ,workspaceId, player)
      // }
      const {
        teamGameId,
        host,
        selfPlayer,
        typeExtract
      } = await this.$store.getters.getSimple([
        "teamGameId",
        "host",
        "selfPlayer",
        "typeExtract"
      ]);
      this.$store.dispatch("simpleSave", {
        typeExtract: "timeout"
      });
      this.$router.push({
        name: "final-team",
        params: { typeFinish: "timeout" }
      });
      if (!typeExtract) {
        let response = await decodeApi.patch(
          `/team-games/${teamGameId}/timeout`
        );
      }
    },
    async verifyAttempts(attemps, selfPlayer) {
      let correct = false;
      let selfCorrect = attemps.some(attempt => {
        if (attempt.correct == true && attempt.enigmaOrder == "equation") {
          correct = true;
        }
        return (
          attempt.enigmaOrder == "equation" &&
          attempt.correct == true &&
          attempt.userId == selfPlayer.id
        );
      });
      if (correct) {
        let hit = "group-hit";
        if (selfCorrect) {
          hit = "self-hit";
        }
        await firebase.destroyedApp();
        this.$store.dispatch("simpleSave", {
          typeExtract: hit
        });
        this.$router.push({ name: "correct-alert" });
        return correct;
      }

      return;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.view = to.name;
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.view = to.name;
    next();
  }
};
</script>
<style lang="scss" scoped>
.default-container {
  height: 100%;
}
</style>
